function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#202124"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M14.378 0h-9.26C2.243 0 .067 2.18 0 4.91l.003.316.024.321C.295 8.092 2.388 10 5.117 10l5.396-.002 8.124 25.409.015.088c.522 2.106 2.524 3.55 4.737 3.55h25.709c2.085 0 3.76-1.093 4.695-2.908l6.924-12.106.126-.2.247-.438.447-.849c.17-.33.29-.678.354-1.036 1.098-6.046-6.245-8.09-9.68-3.157l-.292.434-.512.8-.39.635-.893 1.51-.505.874-1.432 2.542-2.14 3.898H27.275L19.4 3.625C18.448 1.296 16.746 0 14.378 0z",
  transform: "translate(-679 -243) translate(394 160) translate(264 40) translate(21 43)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.051 41.964c4.467 0 7.882 3.644 7.882 7.809 0 4.425-3.415 7.809-7.881 7.809-4.204 0-7.619-3.385-7.619-7.81 0-4.164 3.415-7.808 7.618-7.808z",
  transform: "translate(-679 -243) translate(394 160) translate(264 40) translate(21 43) rotate(.2 26.183 49.773)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.764 41.964c4.392 0 7.75 3.644 7.75 7.809 0 4.425-3.358 7.809-7.75 7.809-4.133 0-7.75-3.385-7.75-7.81 0-4.164 3.617-7.808 7.75-7.808z",
  transform: "translate(-679 -243) translate(394 160) translate(264 40) translate(21 43) rotate(.2 44.764 49.773)"
}))))));

var SvgIconSepet3 = function SvgIconSepet3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 59,
    viewBox: "0 0 62 59",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSepet3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-sepet-3.1403fec5.svg";
export { ForwardRef as ReactComponent };